// TODO copied from ionic-framework core/src/utils/helpers.ts
/**
 * Elements inside of web components sometimes need to inherit global attributes
 * set on the host. For example, the inner input in `ion-input` should inherit
 * the `title` attribute that developers set directly on `ion-input`. This
 * helper function should be called in componentWillLoad and assigned to a variable
 * that is later used in the render function.
 *
 * This does not need to be reactive as changing attributes on the host element
 * does not trigger a re-render.
 */

export const inheritAttributes = (el: HTMLElement, attributes: string[] = []): { [k: string]: any } => {
  const attributeObject: { [k: string]: any } = {};

  const boolAttr = [
    'allowfullscreen',
    'allowpaymentrequest',
    'async',
    'autofocus',
    'autoplay',
    'checked',
    'controls',
    'default',
    'defer',
    'disabled',
    'formnovalidate',
    'hidden',
    'ismap',
    'itemscope',
    'loop',
    'multiple',
    'muted',
    'nomodule',
    'novalidate',
    'open',
    'playsinline',
    'readonly',
    'required',
    'reversed',
    'selected',
    'truespeed',
  ];

  attributes.forEach((attr) => {
    if (el.hasAttribute(attr)) {
      if (boolAttr.indexOf(attr) === -1) {
        const value = el.getAttribute(attr);
        if (value !== null) {
          attributeObject[attr] = el.getAttribute(attr);
        }
      } else {
        attributeObject[attr] = true;
      }
    }
  });

  return attributeObject;
};
